import CommonButton from "@/components/utils/CommonButton";
import IndividualIcon from "@/components/utils/icons/IndividualIcon";
import RocketIcon from "@/components/utils/icons/RocketIcon";
import LazoModal from "@/components/utils/LazoModal";
import { Colors } from "@/enums/Colors";
import { LazoCompanyAccountType } from "@/enums/LazoCompanyAccountType";
import { AddOutlined } from "@mui/icons-material";
import { Box, Button, styled, Typography } from "@mui/material";
import { Dispatch, SetStateAction, useState } from "react";

interface Props {
  isOpen: boolean;
  setIsOpen: Dispatch<SetStateAction<boolean>> | ((open: boolean) => void);
  handleAccountType: (accountType: LazoCompanyAccountType) => void;
  hideTriggerButton?: boolean;
}

export const CreateCompanyAsModal = ({ isOpen, setIsOpen, handleAccountType, hideTriggerButton }: Props) => {
  const [accountType, setAccountType] = useState<LazoCompanyAccountType>(LazoCompanyAccountType.COMPANY);

  const onClickCompany = () => {
    setAccountType(LazoCompanyAccountType.COMPANY);
  };

  const onClickIndividual = () => {
    setAccountType(LazoCompanyAccountType.INDIVIDUAL);
  };

  return (
    <>
      {!hideTriggerButton && (
        <CommonButton
          sx={{
            height: "2.5rem",
            whiteSpace: "nowrap",
            paddingInline: "1rem",
            borderRadius: "0.5rem",
          }}
          endIcon={<AddOutlined />}
          onClick={() => setIsOpen(true)}
        >
          <Typography fontWeight={600}>Create Company</Typography>
        </CommonButton>
      )}
      <LazoModal
        open={isOpen}
        handleClose={() => setIsOpen(false)}
        title="Create As"
        sx={{
          width: "650px",
          "& .content-container": {
            height: "8.25rem !important",
            overflowY: "auto",
            "& > div": {
              height: "inherit",
            },
          },
        }}
        buttons={
          <>
            <CommonButton purpleBorderVariant onClick={() => setIsOpen(false)}>
              Cancel
            </CommonButton>
            <CommonButton onClick={() => handleAccountType(accountType)}>Next</CommonButton>
          </>
        }
      >
        <Box sx={{ width: "100%", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
          <Box sx={{ display: "flex", columnGap: "16px" }}>
            <StyledSelectButton className={accountType === LazoCompanyAccountType.COMPANY && "selected"} onClick={onClickCompany}>
              <RocketIcon />
              Company
            </StyledSelectButton>
            <StyledSelectButton className={accountType === LazoCompanyAccountType.INDIVIDUAL && "selected disabled"} disabled>
              <IndividualIcon />
              Individual
            </StyledSelectButton>
          </Box>
        </Box>
      </LazoModal>
    </>
  );
};

const Text = styled(Typography)(() => ({
  "&.title": {
    color: Colors.BLACK,
    fontSize: "1.5rem",
  },
  "&.select-label": {
    fontWeight: 500,
    color: Colors.LIGHT_GRAY_8A8E93,
    fontSize: "0.75rem",
    paddingBottom: "1rem",
  },
}));

const StyledSelectButton = styled(Button)(() => ({
  display: "flex",
  flexDirection: "column",
  paddingBlock: "16px",
  border: `${Colors.LIGHT_GRAY_DEDEE1} solid 1px`,
  width: "12rem",
  borderRadius: "0.5rem",
  textTransform: "none",
  transition: "all 0.3s",
  "&:hover": {
    border: `${Colors.LAZO_PURPLE} solid 1px`,
  },
  "& svg": {
    width: "1.5rem",
    height: "1.5rem",
    color: Colors.DARK_GREY_3E3E3E,
    transition: "all 0.3s",
  },
  "&.selected": {
    borderColor: Colors.LAZO_PURPLE,
    backgroundColor: Colors.BUTTON_SECONDARY_PURPLE,
    "& svg": {
      color: Colors.LAZO_PURPLE,
    },
  },
  "&.disabled": {
    opacity: 0.5,
    cursor: "not-allowed",
    backgroundColor: Colors.LIGHT_GRAY_DEDEE1,
    "& svg": {
      color: Colors.LIGHT_GRAY_8A8E93,
    },
  },
}));
